import React, { useEffect, useState } from "react";
import s from "./EditableTelekino.module.css";

//Material
import {
  Button,
  CircularProgress,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ModalSearch from "../../../Remitos/Create/Steppers/Modales/Modal/Modal";
import { getDatabyId } from "../../../../../api/delivery/masiveDistribution";
import deliveryServices from "../../../../../api/delivery/DeliveryService";
import Swal from "sweetalert2";
import BallotIcon from "@mui/icons-material/Ballot";
import AgencyModal from "../../../../Shared/AgencyModal";
import { Currency } from "../../../../../helpers/currencyConvert";
import useTranslationException from "../../../../../helpers/exceptions";
const centerGrid = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const EditableTelekino = ({
  getData,
  id,
  setEdit,
  data,
  setItems,
  agencyFirstNumber,
}) => {
  const service = deliveryServices();
  const { t, i18n } = useTranslation();
  const showExpetion = useTranslationException(t, i18n);
  const { textColor } = useSelector((state) => state.local);
  const organization = useSelector((state) => state.gamma.activeOrganization);

  //Estados
  const [loading, setLoading] = useState(false);
  const [loadingSend, setLoadingSend] = useState(false);
  const [open, setOpen] = useState(false);
  const [agencySelected, setAgencySelected] = useState({
    number: agencyFirstNumber,
  });
  const [form, setForm] = useState({});

  const handleBack = () => {
    setEdit({
      status: false,
      id: 0,
    });
  };

  const handleSave = () => {
    if (agencySelected.id) {
      let details = form?.detailList?.map((detail) => {
        return {
          amount: detail.amount,
          gameId: detail.gameId,
          id: detail.id,
          nroCouponFrom: detail.nroCouponFrom,
          nroCouponTo: detail.nroCouponTo,
          raffleId: detail.raffleReadDTO?.id,
        };
      });
      let payload = {
        ...form,
        detailList: [],
        agencyId: agencySelected?.id,
        agencyName: `(${agencySelected?.number}${agencySelected?.subNumber ? ` - ${agencySelected?.subNumber}` : ""}) ${agencySelected?.name}`,
        organizationId: organization.id,
        organizationName: organization.name,
        lotteryId: organization.id,
        lotteryName: organization.name,
      };

      setLoadingSend(true);
      service
        .editDeliveryNote(payload)
        .then(() => {
          getData();
        })
        .then(() => {
          setLoadingSend(false);
          handleBack();
        })
        .catch((e) => {
          showExpetion.showErrorModalForServiceException(
            e,
            { icon: "warning" },
            t("anErrorOccurred,TryAgain"),
            t("sorryErrorOcurred"),
          );
          setLoadingSend(false);
          handleBack();
        });
    }
  };

  useEffect(() => {
    setLoading(true);
    service
      .getDeliveryNoteById(id)
      .then((res) => {
        setForm(res);
      })
      .then(() => setLoading(false))
      .catch((e) => {
        showExpetion.showErrorModalForServiceException(
          e,
          { icon: "warning" },
          t("anErrorOccurred,TryAgain"),
          t("sorryErrorOcurred"),
        );
        setLoading(false);
        handleBack();
      });
  }, []);

  return (
    <Grid container className={s.container}>
      <Grid item container xs={11} className={s.header}>
        <Grid item xs={1}>
          <ArrowBackIcon
            sx={{ fontSize: "2rem", color: "primary.main", mr: 1 }}
            onClick={handleBack}
            className={s.arrow}
          />
        </Grid>
        <Grid item xs={11} lg={11} className={s.titleContainer}>
          <BallotIcon sx={{ fontSize: "2rem", color: "primary.main", mr: 1 }} />
          <h4>{`${t("drawDetail")}: ${data.archive.raffleId}`}</h4>
        </Grid>
      </Grid>
      {loading ? (
        <Grid item xs={12} sx={{ ...centerGrid, height: "400px" }}>
          <CircularProgress size="3rem" />
        </Grid>
      ) : (
        <>
          <AgencyModal
            open={open}
            setOpen={setOpen}
            selectAgency={setAgencySelected}
          />
          <Grid
            item
            container
            xs={10}
            spacing={2}
            className={s.confirmHeaderData}
          >
            <Grid item xs={5} sx={{ mb: 3 }}>
              <TextField
                label={`${t("deliveryNoteNumber")} de ${t("entrance")}`}
                sx={{ width: "90%" }}
                value={form.nroInput}
                disabled
              />
            </Grid>
            <Grid item xs={5} sx={{ mb: 3 }}>
              <TextField
                label={t("date")}
                sx={{ width: "90%" }}
                value={form.date?.split("T")[0].split("-").reverse().join("-")}
                disabled
              />
            </Grid>
            <Grid item xs={5} sx={{ mb: 3 }}>
              <TextField
                label={`${t("type")} de ${t("deliveryNote")}`}
                sx={{ width: "90%" }}
                value={t("entrance")}
                disabled
              />
            </Grid>
            <Grid item xs={5} sx={{ mb: 3 }}>
              <TextField
                label={t("observations")}
                sx={{ width: "90%" }}
                value={form.observations}
                disabled
              />
            </Grid>
            <Grid item container xs={5} sx={{ mb: 3 }}>
              <TextField
                label={`${t("agency")} ${t("destinationAddress")}`}
                sx={{ width: "60%" }}
                value={`(${agencySelected.number}${agencySelected?.subNumber ? ` - ${agencySelected?.subNumber}` : ""}) ${agencySelected.name ? `- ${agencySelected.name}` : ""}`}
              />
              <Grid item xs={3} sx={{ ...centerGrid, ml: 3 }}>
                <Button variant="contained" onClick={() => setOpen(true)}>
                  {t("consult")}
                </Button>
              </Grid>
            </Grid>
            <Grid item container xs={5} sx={{ mb: 3 }}></Grid>
          </Grid>

          <Grid item xs={10} className={s.twoData}>
            <h4>{t("details")}</h4>
            <TableContainer className={s.tableContainer}>
              <Table>
                <TableHead sx={{ backgroundColor: "primary.main" }}>
                  <TableCell
                    sx={{
                      color: textColor,
                      fontSize: ".9rem",
                      fontWeight: 500,
                      fontFamily: "Roboto, sans-Serif",
                    }}
                  >
                    {t("quantity")}
                  </TableCell>
                  <TableCell
                    sx={{
                      color: textColor,
                      fontSize: ".9rem",
                      fontWeight: 500,
                      fontFamily: "Roboto, sans-Serif",
                    }}
                  >{`${t("packages")}/${t("coupons")}`}</TableCell>
                  <TableCell
                    sx={{
                      color: textColor,
                      fontSize: ".9rem",
                      fontWeight: 500,
                      fontFamily: "Roboto, sans-Serif",
                    }}
                  >
                    {t("serie")}
                  </TableCell>
                  <TableCell
                    sx={{
                      color: textColor,
                      fontSize: ".9rem",
                      fontWeight: 500,
                      fontFamily: "Roboto, sans-Serif",
                    }}
                  >
                    {t("drawNumber")}
                  </TableCell>
                  <TableCell
                    sx={{
                      color: textColor,
                      fontSize: ".9rem",
                      fontWeight: 500,
                      fontFamily: "Roboto, sans-Serif",
                    }}
                  >
                    {t("price")}
                  </TableCell>
                  <TableCell
                    sx={{
                      color: textColor,
                      fontSize: ".9rem",
                      fontWeight: 500,
                      fontFamily: "Roboto, sans-Serif",
                    }}
                  >
                    {t("percentageMinorPrizesBrief")}
                  </TableCell>
                </TableHead>
                <TableBody>
                  {form?.detailList?.map((item, i) => (
                    <React.Fragment key={i}>
                      <TableRow>
                        <TableCell>
                          {item?.nroCouponTo - item?.nroCouponFrom + 1}
                        </TableCell>
                        <TableCell>
                          {item?.nroCouponFrom}-{item.nroCouponTo}
                        </TableCell>
                        <TableCell>
                          {item?.raffleReadDTO?.serie || "-"}
                        </TableCell>
                        <TableCell>
                          {item?.raffleReadDTO?.number || "-"}
                        </TableCell>
                        <TableCell>
                          <Currency value={item?.raffleReadDTO?.price} />
                        </TableCell>
                        <TableCell>
                          {item?.raffleReadDTO?.percentage
                            ? `${item.raffleReadDTO.percentage} %`
                            : "-"}
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>

          <Grid item xs={12} sx={{ ...centerGrid, ml: 3, mb: 5 }}>
            <Button
              variant={loadingSend ? "" : "contained"}
              onClick={handleSave}
              disabled={!agencySelected.name}
              className={s.btn}
            >
              {loadingSend ? <CircularProgress /> : t("save")}
            </Button>
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default EditableTelekino;
